let cachedManualText = null;
let pendingFetch = null;

export function getManualText() {
  if (cachedManualText) {
    return Promise.resolve(cachedManualText);
  }
  if (!pendingFetch) {
    pendingFetch = fetch("/manual/MANUAL_USUARIO.md").then((response) => {
      if (!response.ok) {
        throw new Error("No se pudo cargar el manual de usuario.");
      }
      return response.text();
    });
  }
  return pendingFetch.then((texto) => {
    cachedManualText = texto;
    return texto;
  });
}

export function extractManualSection(markdown, headingText) {
  const lines = markdown.split(/\r?\n/);
  const headingRegex = /^(#{1,6})\s+(.*)$/;

  let startIndex = -1;
  let level = 0;
  for (let i = 0; i < lines.length; i += 1) {
    const match = lines[i].match(headingRegex);
    if (match && match[2].trim() === headingText) {
      startIndex = i;
      level = match[1].length;
      break;
    }
  }
  if (startIndex === -1) {
    return null;
  }

  let endIndex = lines.length;
  for (let i = startIndex + 1; i < lines.length; i += 1) {
    const match = lines[i].match(headingRegex);
    if (match && match[1].length <= level) {
      endIndex = i;
      break;
    }
  }

  return lines.slice(startIndex, endIndex).join("\n").trim();
}

// Replica el algoritmo de slugs de GitHub (el mismo que se usó a mano para
// armar los links del índice en MANUAL_USUARIO.md), para poder generarle un
// id a cada heading renderizado y que esos links funcionen.
export function slugify(text) {
  return text
    .toLowerCase()
    .normalize("NFC")
    .replace(/[^\p{L}\p{N} -]+/gu, "")
    .trim()
    .replace(/\s+/g, "-");
}
